import Vue from 'vue'
import App from './App.vue'
import Vuelidate from "vuelidate";
import Snotify from 'vue-snotify';
import store from "./states"

import router from './router.js'
import { BootstrapVue , IconsPlugin } from 'bootstrap-vue'
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueCookies from 'vue-cookies'


import './assets/scss/style.scss'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.css'
import '@/assets/css/bootstrap-rtl.css'


Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueCookies)
Vue.use(IconsPlugin)

Vue.component(VueCountdown.name, VueCountdown);
Vue.use(Snotify, {
  toast: {
    timeout: 5000,
    showProgressBar: false,
  }
})
import 'vue-snotify/styles/material.css'; // or dark.css or simple.css
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
